import {
  SET_USER_STATEMENTS,
  SET_STATEMENT_YEARS,
  SET_DONOR_DONATIONS,
  SET_AUTHORISATION,
  CLEAR_SWIFTAID_AUTHORISATION,
  SET_SWIFTAID_AUTHORISED,
  SET_AUTHORISATION_STATUS_KNOWN,
  SET_USER,
  SET_POSTED_USER,
  SET_REFERRAL_LINK,
  SET_LANDING_PAGE,
  SET_USER_EMAIL,
  SET_SWIFTAID_GIVING_PLAN,
  SET_SWIFTAID_GIVING_SUBSCRIPTION,
  SET_SWIFTAID_GIVING_FEATURES,
  SET_DONOR_PLAN_STATUS_KNOWN,
  SET_DASHBOARD_SEEN,
  SET_SCHEDULED_FOR_DELETION,
} from '@/store/mutation-types'

export default {
  [SET_USER_STATEMENTS](state: any, payload: any) {
    // OpenAPI: { statements: Statement[] }; tolerate legacy bare array in tests
    state.statements = Array.isArray(payload)
      ? payload
      : (payload?.statements ?? [])
  },
  [SET_STATEMENT_YEARS](state: any, payload: any) {
    // OpenAPI: { years: string[], hasHistoricYears: boolean }
    state.statementYears = {
      years: payload?.years ?? [],
      hasHistoricYears: payload?.hasHistoricYears ?? false,
    }
  },
  [SET_DONOR_DONATIONS](state: any, payload: any) {
    state.financialYears = payload.financialYears
  },
  [SET_AUTHORISATION](state: any, payload: any) {
    state.authorisation = payload
  },
  [CLEAR_SWIFTAID_AUTHORISATION](state: any) {
    state.authorisation = {}
  },
  [SET_SWIFTAID_AUTHORISED](state: any, payload: any) {
    state.swiftaidAuthorised = payload
  },
  [SET_AUTHORISATION_STATUS_KNOWN](state: any, payload: boolean) {
    state.authorisationStatusKnown = payload
  },
  [SET_USER](state: any, payload: any) {
    const previousLandingPage = state.userDetails?.landingPage
    const previousEmail = state.userDetails?.emailAddress
    // Clone so we never mutate the Axios/Mirage response object — callers read
    // `response.data.landingPage` after this commit (mock signup navigation).
    const nextUser = {
      ...payload,
      details: payload?.details ? { ...payload.details } : payload?.details,
      accounts: Array.isArray(payload?.accounts)
        ? [...payload.accounts]
        : payload?.accounts,
    }
    state.userDetails = nextUser

    // Never regress a completed onboarding donor (landingPage 100) because of a
    // stale GET /me or a just-provisioned POST /me — including same-email signup
    // completions.
    if (
      previousLandingPage === 100 &&
      typeof nextUser.landingPage === 'number' &&
      nextUser.landingPage < 100
    ) {
      const sameDonor =
        Boolean(previousEmail) &&
        Boolean(nextUser.emailAddress) &&
        String(previousEmail).toLowerCase() ===
          String(nextUser.emailAddress).toLowerCase()
      // Allow a brand-new signup email to replace a finished persona/account.
      if (sameDonor || !nextUser.emailAddress) {
        state.userDetails.landingPage = previousLandingPage
      }
    }
  },
  [SET_POSTED_USER](state: any, payload: any) {
    state.userDetails.details = payload
  },
  [SET_REFERRAL_LINK](state: any, payload: any) {
    state.referralLink = payload
  },
  [SET_SCHEDULED_FOR_DELETION](state: any, payload: boolean) {
    state.scheduledForDeletion = payload
  },
  [SET_LANDING_PAGE](state: any, payload: any) {
    state.userDetails.landingPage = payload
  },
  [SET_USER_EMAIL](state: any, payload: any) {
    state.userDetails.emailAddress = payload
  },
  [SET_SWIFTAID_GIVING_PLAN](state: any, payload: 'free' | 'paid') {
    state.swiftaidGivingPlan = payload
  },
  [SET_SWIFTAID_GIVING_SUBSCRIPTION](state: any, payload: any) {
    state.swiftaidGivingSubscription = payload ?? null
  },
  [SET_SWIFTAID_GIVING_FEATURES](state: any, payload: any) {
    state.swiftaidGivingFeatures = payload ?? null
  },
  [SET_DONOR_PLAN_STATUS_KNOWN](state: any, payload: boolean) {
    state.donorPlanStatusKnown = payload
  },
  [SET_DASHBOARD_SEEN](state: any, payload: { dashboardSeen: boolean; dashboardFirstSeenAt?: string | null }) {
    if (!state.userDetails) return
    state.userDetails.dashboardSeen = payload.dashboardSeen
    if (payload.dashboardFirstSeenAt !== undefined) {
      state.userDetails.dashboardFirstSeenAt = payload.dashboardFirstSeenAt
    }
  },
}
